import { Vue } from 'vue-property-decorator';

export class TopicListSerializer extends Vue {
    public static INSTANCE = new TopicListSerializer();
    static get instance() {
        return this.INSTANCE;
    }
    public serializeTopicList(payload: any) {
        const topicList = {
            list: payload.data,
            listCount: payload.count,
        };
        return topicList;
    }

    public serializeTenantList(payload: any) {
        const tenantList = payload.map((item: any) => ({
            text: item.name,
            value: item.id,

        }));
        return tenantList;
    }
}

export const topicListSerializer = TopicListSerializer.instance;
